module.exports = __webpack_public_path__ + "static/media/Golf Hole Ball.9d28f7a0.svg";